// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"528edcd3","977":"81e292d4"}[chunkId] + ".chunk.js";
};